/**
 * Design tokens the Quality Check screens share, from the design handoff
 * (`design_handoff_quality_check`, "Design Tokens").
 *
 * A module rather than a const on whichever component happened to need it first: the audit
 * tint is used by the correction dialog's tag and by the card's audit trail, and parking it
 * in either one made the two components import each other. It is also not an image fact, so
 * it does not belong in `imageMeta.ts` beside the image model.
 *
 * These are hard-coded because the theme has no equivalent pair — its `info.light` is a
 * saturated cyan that reads as an alert, and the handoff's instruction is to prefer the
 * codebase's tokens only "where they already match".
 */
export const AUDIT_TINT = { bg: '#E7F0FB', fg: '#1761AE' };

/**
 * MUI's Chip keeps its label on one line and ellipsises the overflow. Inside the
 * gallery's narrow columns that clipped five of the twelve category labels — including
 * "Patient identifiable in the photo" and "Identifiable, but not ticked in the app",
 * which is the reviewer ticking a safeguarding flag they cannot read. There is no
 * `title` either, so hovering revealed nothing. Let the label wrap and the chip grow
 * to fit it: a two-line chip costs vertical space, an unreadable one costs the answer.
 */
export const READABLE_CHIP_SX = {
    height: 'auto',
    maxWidth: '100%',
    '& .MuiChip-label': {
        whiteSpace: 'normal',
        overflow: 'visible',
        textOverflow: 'clip',
        paddingTop: '4px',
        paddingBottom: '4px',
        lineHeight: 1.35,
    },
} as const;
